import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { ConsentContainer } from './containers';
import { updateBodyClass } from 'src/helpers';
import { CONSENT_URL } from 'src/constants/constants.js';
import { BODY_CLASSES } from 'src/constants/constants';
import Layout from 'src/ui/layout';
import withRouter from 'src/utils/withRouter';

const ConsentContainerWithRouter = withRouter(ConsentContainer);

class ConsentRoot extends React.Component {
  componentDidMount() {
    updateBodyClass(BODY_CLASSES.CONSENT);
  }

  componentWillUnmount() {
    updateBodyClass(BODY_CLASSES.CONSENT);
  }

  render() {
    return (
      <Layout headerName={'Legal Consent'}>
        <Routes>
          <Route path={'*'} element={<ConsentContainerWithRouter key={'consent'} />} />
        </Routes>
      </Layout>
    );
  }
}

export default ConsentRoot;
